import React, { Component } from "react";
import { Field, reduxForm, FormSection, formValueSelector, reset } from "redux-form";
import {  Button } from 'reactstrap';
import classnames from 'classnames';
import { connect } from "react-redux";
import PropertyReportMrtgForm  from "./PropertyReportMrtg";
import { CallAPI } from "../common/formsubmit";
import appConfig from '../../config/config';
import PropertyReportMrtgGrid from "./PropertyReportMrtgGrid";
import PropertyReportMrtg from "./PropertyReportMrtg";
import { LoadAllMrtgs, SetMrtg, ShowAddMrtg } from "../../actions/loading";
const colHeader = [
    { dataField: 'ID', text: 'Sr No' },
    { dataField: 'Mortgagee', text: 'Mortgagee' },
    { dataField: 'Grantor', text: 'Mortgagor' },
    { dataField: 'Prior', text: 'Mortgage Date' },
    { dataField: 'DEEDDATE', text: 'Rec Date' },
    { dataField: 'RECDATE', text: 'Rec Date' },
    { dataField: 'VOLINST', text: 'Vol-Inst' },
    { dataField: 'PAGE', text: 'Page' }
];
var orderColumns = colHeader.map(function (d) { return { dataField: d.dataField, text: d.text, sort: true } });


class PropertyReportMrtgMain extends Component {
    constructor(...args) {
        super(...args);
        
    }
    componentDidMount() {

        CallAPI(
            {"OrderId":this.props.OrderId,"OrderProductId":this.props.OrderProductId},
            appConfig.apiGateway.PropertyReport,
            this.props,
            "GetMrtgs",
            this.props.Error,
            this.props.Error,this.props.LoadAllMrtgs)
            if (this.props.allmrtgs && this.props.allmrtgs.length > 0)
                this.props.SetMrtg(this.props.allmrtgs[0])
    }
    render() {
        return (
            <>
            <PropertyReportMrtgGrid OrderColumns={orderColumns}/>
            <PropertyReportMrtg OrderId={this.props.OrderId} />
            <Button type="button" onClick={()=> {
                         this.props.ShowAddMrtg()
                    }}>Add Mortgage</Button>
            </>
        );
    }
}
const validate = (formValues) => {
    const errors = {};
    return errors;
}
var propertyReportMrtgMainForm = reduxForm({
    form: 'propertyReportMrtgMainForm',
    validate
})(PropertyReportMrtgMain);

propertyReportMrtgMainForm = connect(
    state => ({
        session: state.session,
        allmrtgs: state.loadDeed.allmrtgs
    }),
    { LoadAllMrtgs, SetMrtg, ShowAddMrtg }
)(propertyReportMrtgMainForm);

export default propertyReportMrtgMainForm;